import { Outlet, useLocation } from 'react-router-dom';
import NavbarOld from "@/components/elements/Navbar/NavbarOld";
import Footer from "@/components/elements/Footer/Footer";
import Copyright from "@/components/elements/Copyright/Copyright";

const MainLayout = () => {
  const location = useLocation();

  const isHomePage = location.pathname === "/"; // ✅ update this if it's "/"
  const isContactPage = location.pathname === "/contact";

  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden">
      <NavbarOld />

      <main className={`${isContactPage ? "bg-background" : ""} flex-1`}>
        <div
          className={`w-full max-w-[1920px] mx-auto ${
            !isHomePage ? "" : ""
          }`}
        >
          <Outlet />
        </div>
      </main>

      <Footer />
      <Copyright />
    </div>
  );
};

export default MainLayout;
